module.exports = __webpack_public_path__ + "img/drama.4f9ee3fb.svg";